<template>
  <!--
    This empty div serves as a mounting point for the Novu Inbox.
    We use Vue's ref attribute to get direct access to this DOM element.
  -->
  <div ref="novuInbox"></div>
</template>

<script setup >
import { ref, onMounted, onUnmounted } from "vue";
import { NovuUI } from "@novu/js/ui";
import { useStore } from "vuex";

const store = useStore();


// interface NovuOptions {
//   options: {
//     applicationIdentifier: string;
//     subscriberId: string;
//   };
// }

// Create a reactive reference to hold the DOM element
const novuInbox = ref(null);
// Store the Novu instance for cleanup during unmount
let novuInstance = null;

onMounted(() => {
  // Ensure our div reference exists before proceeding
  if (!novuInbox.value) {
    console.error("Novu inbox container element not found");
    return;
  }

  try {
    // Initialize the Novu UI instance with required configuration
    const novu = new NovuUI({
      options: {
        applicationIdentifier: 'xqT0o1n8Pxwo',
        subscriberId: store.state.init.user.key,
      },
    });

    // Mount the Inbox component to our div reference
    // This is where Novu creates and injects its Inbox UI
    novu.mountComponent({
      name: "Inbox",
      props: {},
      element: novuInbox.value, // The actual DOM element where Inbox will be mounted
    });

    // Store the instance for cleanup
    novuInstance = novu;
  } catch (error) {
    console.error("Failed to initialize Novu inbox:", error);
  }
});

// Clean up when the component is destroyed
onUnmounted(() => {
  if (novuInstance && novuInbox.value) {
    try {
      // Properly unmount the Novu component to prevent memory leaks
      novuInstance.unmountComponent(novuInbox.value);
    } catch (error) {
      console.error("Failed to unmount Novu inbox:", error);
    }
  }
});
</script>

<style>
.nv-bellContainer,
.nv-bellContainer button,
.nv-bellContainer svg {
  color: #3a3d4a !important;
  fill: currentColor;
}
</style>